import { forDarkThemes } from "../externalImages";
import branding from "./branding";
import experimental from "./experimental";
import monaco from "./monaco";
import palette from "./palette";
import roles from "./roles";

export default {
	palette,
	externalImages: forDarkThemes,
	experimental,
	branding,
	monaco,
	roles,
};
